import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { triggerPopup } from '../../../actions/backdrop'
import { getPriceModelConflictsCustomer, updatePriceModelConflicts } from '../../../actions/priceModelConflict'
import { getCustomerAgrements } from '../../../actions/agreement'
import { getCustomerContactsInfo } from '../../../actions/customerWP'
import { loginAs } from '../../../actions/auth'

// Utils
import { translation } from '../../../utils/helpers'

import DealerSettings from '../../../shared/components/DealerSettings'
// Styles
import './view.scss'
import '../conflicts.scss'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Grid from '../../../shared/elements/grid'
import Panel from '../../../shared/elements/panel'
import Button from '../../../shared/elements/button'
import Radio from '../../../shared/elements/radio'
// import LabelWrapper from '../../../shared/elements/labelWrapper'
import Divider from '../../../shared/elements/divider'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'view',
      customersList: [],
      companyAgreements: [
        {
          agreementsList: [],
          addonList: [],
          complaintList: [],
          insuranceList: [],
          otherList: [],
          privateList: [],
          salescarList: [],
          warrantyList: [],
          companyName: ''
        }
      ],
      customerContactsList: [],
      selectedDealer: {},
      customerGroups: []
    }
    this.onChange = this.onChange.bind(this)
    this.renderItem = this.renderItem.bind(this)
    this.getConflictsCustomer = this.getConflictsCustomer.bind(this)
    this.saveConflict = this.saveConflict.bind(this)
    this.renderAgreements = this.renderAgreements.bind(this)
    this.getCustomerAgreements = this.getCustomerAgreements.bind(this)
    this.getCustomerContactsInfo = this.getCustomerContactsInfo.bind(this)
    this.renderCompanyAgreements = this.renderCompanyAgreements.bind(this)
  }

  componentDidMount () {
    this.getConflictsCustomer()
  }

  getConflictsCustomer (customerId) {
    if (customerId === undefined) {
      customerId = this.props.item.CustomerId
    }
    if (Number(customerId) !== Number(-1)) {
      this.props.getPriceModelConflictsCustomer(customerId).then((res) => {
        this.setState({
          customersList: res.data
        })
      })
      this.getCustomerAgreements(customerId)
      this.getCustomerContactsInfo(customerId)
    }
  }

  loginAs (id) {
    this.props.loginAs(id).then((res) => {
      this.props.router.push(res.data.StartScreen !== null ? res.data.StartScreen : '/orders/')
    })
  }

  getCustomerAgreements (customerId) {
    this.props.getCustomerAgrements(customerId).then((res) => {
      let details = res.data
      var companyAgreements = []
      for (let i = 0; i < details.CompanyAgreements.length; i++) {
        let detail = details.CompanyAgreements[i]
        let addon = []
        let complaint = []
        let insurance = []
        let other = []
        let privates = []
        let salescar = []
        let warranty = []
        for (let a = 0; a < detail.AgreementsList.length; a++) {
          let item = detail.AgreementsList[a]
          switch (item.PriceType) {
            case 0: // Other
              other.push(item)
              break
            case 1: // Salescar
              salescar.push(item)
              break
            case 2: // Private
              privates.push(item)
              break
            case 3: // Warranty
              warranty.push(item)
              break
            case 5: // Estimation
              insurance.push(item)
              break
            case 6: // Complaint
              complaint.push(item)
              break
            case 8:
              addon.push(item)
              break
          }
        }
        companyAgreements.push({
          agreementsList: detail.AgreementsList,
          companyName: detail.CompanyName,
          addonList: addon,
          complaintList: complaint,
          insuranceList: insurance,
          otherList: other,
          privateList: privates,
          salescarList: salescar,
          warrantyList: warranty
        })
      }
      this.setState({
        companyAgreements: companyAgreements,
        customerGroups: details.CustomerGroups
      })
    })
  }
  getCustomerContactsInfo (customerId) {
    this.props.getCustomerContactsInfo(customerId).then((res) => {
      let customer = res.data.Customer
      if (customer.CustomerId === 0) customer.CustomerId = customerId
      this.setState({
        customerContactsList: res.data.Contacts,
        selectedDealer: customer
      })
    })
  }

  saveConflict (data) {
    this.props.updatePriceModelConflicts(data).then((res) => {
      this.setState({
        customersList: res.data
      }, () => {
        this.props.getConflictList()
        // window.toastr.success(translation('13027'), translation('13424'))
      })
    }, () => {
      window.toastr.error(translation('13028'), translation('216'))
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.CustomerId !== nextProps.item.CustomerId) {
      this.setState({
        customersList: [],
        companyAgreements: [],
        customerContactsList: [],
        selectedDealer: {},
        customerGroups: []
      }, () => {
        this.getConflictsCustomer(nextProps.item.CustomerId)
      })
    }
  }

  onChange (e) {
    e.persist()
    let value = parseInt(e.target.value)
    let conflictName = parseInt(e.target.name)
    let customersList = [...this.state.customersList]
    for (var i = 0; i < customersList.length; i++) {
      let item = customersList[i]
      if (item.PriceModelConflictId === conflictName) {
        item.ResolvedToPriceModelId = value
        customersList[i] = item
        this.setState({
          customersList
        }, () => {
          this.saveConflict(item)
        })
      }
    }
  }

  renderItem (val, key) {
    let conflictId = val.PriceModelConflictId
    let resolvedId = val.ResolvedToPriceModelId
    const renderConflictModel = (val, key) => {
      let inputId = 'ResolvedToPriceModelId_' + conflictId + '_' + val.PriceModelId
      let labelText = val.CustomerGroupName + ', ' + val.Name
      let radioClassName = ''
      if (val.PriceModelId === 0) {
        labelText = translation('433') + ' ' + val.Name
      }
      if (val.Active === false) {
        radioClassName += ' inactive' // background: #eaeaea;
      }
      let hasBrand = (val.Brand !== null && val.Brand !== '')
      let brandName = '(' + val.Brand + ')'
      return (
        <div key={key} className={radioClassName}>
          <Radio labelText={labelText} id={inputId} name={conflictId} value={val.PriceModelId} onChange={this.onChange} checked={val.PriceModelId === resolvedId} />
          {hasBrand && (<span>{brandName}</span>)}
        </div>
      )
    }
    return (
      <Panel key={key} title={translation(val.PriceTypeName) + ', ' + val.CompanyName}>
        {val.PriceModels.map(renderConflictModel)}
      </Panel>
    )
  }
  renderAgreements (agreement, key) {
    const renderType = (list, name) => {
      if (list === undefined || list.length === 0) return null
      return (
        <div className='agreements'>
          <h3>{translation(name)}</h3>
          <Divider />
          {list.map(renderAgreement)}
        </div>
      )
    }
    const renderAgreement = (val, key) => {
      let labelText = val.CustomerGroupName + ', ' + val.Name
      let className = 'spacing '
      if (val.Active === false) {
        className += 'inactive' // background: #eaeaea;
      }
      if (val.PriceModelId === 0) {
        labelText = translation('433') + ' ' + val.Name
      }
      let hasBrand = (val.Brand !== null && val.Brand !== '')
      let brandName = '(' + val.Brand + ')'
      return (
        <div className={className} key={key}>
          <span>{labelText}</span>
          {hasBrand && (<div>{brandName}</div>)}
        </div>
      )
    }

    let title = translation('1738') + ', ' + agreement.companyName
    return (
      <Panel title={title}>
        {renderType(agreement.addonList, '1396')}
        {renderType(agreement.complaintList, '301')}
        {renderType(agreement.insuranceList, '13360')}
        {renderType(agreement.otherList, '73')}
        {renderType(agreement.privateList, '785')}
        {renderType(agreement.salescarList, '71')}
        {renderType(agreement.warrantyList, '13361')}
      </Panel>
    )
  }
  renderCompanyAgreements () {
    return (
      <div>
        {this.state.companyAgreements.map(this.renderAgreements)}
      </div>
    )
  }
  renderDealerInfos () {
    const renderDealerContacts = (val, key) => {
      return (
        <div key={key}>
          <Grid>
            <span>{translation('1')}:</span>
            <span>{val.UserName}</span>
          </Grid>
          <Grid>
            <span>{translation('1052')}:</span>
            <span>{val.Email}</span>
          </Grid>
          <Grid>
            <span>{translation('345')}:</span>
            <span>{val.Phone}</span>
          </Grid>
          <Button size='m' style='link' onClick={this.loginAs.bind(this, val.UserId)} labelText={translation('57')} />
          <Divider />
        </div>
      )
    }
    const renderDealerCustomerGroupInfo = (val, key) => {
      return (
        <div key={key}>{val.Name}</div>
      )
    }
    const renderDealerInfo = (data) => {
      if (data === null || data === undefined || data.CustomerId === 0) return
      return (
        <div>
          <Grid>
            <div>{translation('30')}:</div>
            <div>{data.CompanyName}</div>
          </Grid>
          <Grid>
            <div>{translation('25')}:</div>
            <div>{data.CompanyAddress + ', ' + data.CompanyZipCode + ' ' + data.CompanyCity}</div>
          </Grid>
          <Grid>
            <div>{translation('41')}:</div>
            <div>{data.CompanyCVR}</div>
          </Grid>
          <Grid>
            <div>{translation('38')}:</div>
            <div>{data.CompanyPhoneNumber}</div>
          </Grid>
          <Grid>
            <div>{translation('93')}:</div>
            <div>{data.Notes}</div>
          </Grid>
          <Grid>
            <div>{translation('13660')}:</div>
            <div>{data.ShopName}</div>
          </Grid>
        </div>
      )
    }

    return (
      <Panel title={this.state.selectedDealer.CompanyName}>
        <h3>{translation('13600')}</h3>
        <Divider />
        {renderDealerInfo(this.state.selectedDealer)}
        <h3>{translation('12308')}</h3>
        <Divider />
        {this.state.customerGroups.map(renderDealerCustomerGroupInfo)}
        <h3>{translation('13601')}</h3>
        <Divider />
        {this.state.customerContactsList !== undefined ? this.state.customerContactsList.map(renderDealerContacts) : null}
      </Panel>
    )
  }

  render () {
    // let classNameList = '' // (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    return (
      <Row>
        <Col>
          {this.state.customersList.map(this.renderItem)}
          {this.renderCompanyAgreements()}
        </Col>
        <Col>
          <DealerSettings CustomerId={this.state.selectedDealer.CustomerId} />
          {this.renderDealerInfos()}
        </Col>
      </Row>
    )
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceModelConflictsCustomer,
  updatePriceModelConflicts,
  getCustomerAgrements,
  getCustomerContactsInfo,
  triggerPopup,
  loginAs
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Conflicts/View/index.js